import React, {Component} from 'react';
import {connect} from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import * as A from '../store/lineageActions';
import {schemaLabel} from '../../../util/schema-label';

/**
 * Picks a DD schema from /dataDictionary/schemas (cached in Redux).
 * onChange(schemaId) — caller stores the id.
 *
 * Options are labelled `Dictionary / schema`: this list spans every dictionary,
 * and MS SQL Server dictionaries all contain schemas named dbo/Sales/HR, so the
 * bare schema name is ambiguous.
 */
class DdSchemaPicker extends Component {
  componentDidMount() {
    this.props.fetchDdSchemas();
  }

  render() {
    const {value, onChange, ddSchemas, label} = this.props;
    const pickerLabel = label || 'DD schema';
    return (
      <FormControl fullWidth>
        <InputLabel>{pickerLabel}</InputLabel>
        <Select
          value={value || ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          inputProps={{'data-testid': 'dd-schema-picker-select'}}
        >
          <MenuItem value=""><em>None</em></MenuItem>
          {ddSchemas.map((s) => (
            <MenuItem key={s.schemaId || s.id} value={s.schemaId || s.id}>
              {schemaLabel(s) || s.schemaId || s.id}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

const mapStateToProps = (state) => ({ddSchemas: state.lineageReducer.ddSchemas});

export default connect(mapStateToProps, {fetchDdSchemas: A.fetchDdSchemas})(DdSchemaPicker);
